import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sign-up-dialog',
  templateUrl: './sign-up-dialog.component.html',
  styleUrls: ['./sign-up-dialog.component.scss']
})
export class SignUpDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
